import React from 'react';
import { Link } from 'react-router-dom';
import '../style/Footer.css';
//  Add Image Imports:
// import fbLogo from '../assests/facebookLogo.png';
import instaLogo from '../assests/instaLogo.png';
import ytLogo from '../assests/youtubeLogo.png';
import brandLogo from '../assests/InvoiceLOGO.jpeg';

const Footer = () => {
  return (
    <footer className="footer-target">
      <div className="footer-target-container">

        {/* Col 1: Brand Info */}
        <div className="footer-col">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem' }}>
            <img
              src={brandLogo}
              alt="SS Robotics Logo"
              style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '8px' }}
            />
            <h3 className="footer-brand-title" style={{ margin: 0 }}>SS Robotics</h3>
          </div>
          <p className="footer-brand-sub">Bridging innovation with automation. At SS Robotics, we deliver both online
            and offline excellence in hardware and automation solutions.</p>
        </div>

        {/* Col 2: Quick Links */}
        <div className="footer-col">
          <h4 className="footer-col-title">Quick Links</h4>
          <ul className="footer-links-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/cart">Cart</Link></li>
            <li><Link to="/register">Register</Link></li>
            <li><Link to="/login">Login</Link></li>
          </ul>
        </div>

        {/* Col 3: Contact Info */}
        <div className="footer-col">
          <h4 className="footer-col-title">Contact</h4>
          <div className="footer-contact-item">
            <span>📍</span>
            <span>SS Robotics, Yadunandan nagar tifra bilaspur</span>
          </div>
          <div className="footer-contact-item">
            <span>📞</span>
            <span>+91 88188 87990</span>
          </div>
          <div className="footer-contact-item">
            <span>✉️</span>
            <span>ssrobotics.2002@gmail.com</span>
          </div>
        </div>

        {/* Col 4: Follow Us Social Media */}
        <div className="footer-col">
          <h4 className="footer-col-title">Follow Us</h4>
          {/* <div className="footer-social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              🌐
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              📷
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              🎥
            </a>
          </div> */}
          <div className="footer-social-icons">
            {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              <img src={fbLogo} alt="Facebook" style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
            </a> */}
            <a href="https://www.instagram.com/robotics_with_syamantak?utm_source=qr&stkn=eW5qbjZrbDhwazF4" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              <img src={instaLogo} alt="Instagram" style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
              <img src={ytLogo} alt="YouTube" style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
            </a>
            {/* for future implementation - by rajan */}
          </div>
        </div>

      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom-bar">
        <p>&copy; {new Date().getFullYear()} SS Robotics. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;